import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"height":"100%","position":"relative"} }

import addMedic from "@/views/patientMain/editMedic/addMedic.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'addTtt',
  props: {
  treatmentAdded: {
    type: Function,
    required: false
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "bg-modal w-maxC",
      style: {"position":"absolute","top":"0","right":"0","cursor":"auto","width":"30rem"},
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createVNode(addMedic, {
        autoFocus: true,
        resizeCombo: true,
        treatmentAdded: __props.treatmentAdded
      }, null, 8, ["treatmentAdded"])
    ])
  ]))
}
}

})